import { combineReducers } from "redux";

import ChatsReducer from "./ChatsReducer";
import CurrentChatReducer from "./CurrentChatReducer";

export default combineReducers({
  chats: ChatsReducer,
  currentChat: CurrentChatReducer
});
